import Axios from 'axios';

Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';
Axios.defaults.headers.common['X-Accept'] = 'application/json';

export default class PressReleaseService {
  baseUrl = '/api/v3/pressrelease-checkout';

  constructor(checkoutToken) {
    this.checkoutToken = checkoutToken;
  }

  async createPressRelease(pressRelease) {
    const url = `${this.baseUrl}/`;
    const response = await Axios.post(url, pressRelease);
    return response;
  }

  async getPressRelease() {
    const url = `${this.baseUrl}/${this.checkoutToken}/`;
    const response = await Axios.get(url);
    return response;
  }

  async getMetaData() {
    const url = `${this.baseUrl}/`;
    const response = await Axios.get(url);
    return response;
  }

  async updatePressRelease(pressRelease) {
    const url = `${this.baseUrl}/${this.checkoutToken}/`;
    const response = await Axios.patch(url, pressRelease);
    return response;
  }

  async deletePressRelease() {
    const url = `${this.baseUrl}/${this.checkoutToken}/`;
    const response = await Axios.delete(url);
    return response;
  }
}
